import { Outlet } from "react-router-dom";
import { Navigation } from "../Navigation";

const ENVIRONMENT = import.meta.env.VITE_ENVIRONMENT;

export const AppLayout = () => {
  const mainTopMargin = ENVIRONMENT === 'dev' ? 'mt-20' : 'mt-14';
  
  return (
    <>
      <Navigation />
      <main className={`p-4 ${mainTopMargin}`}>
        <Outlet />
      </main>
    </>
  );
};